import { WooCommerceAccountBlock } from "@/integrations/wordpress/WooCommerceAccountBlock";
export default function Account() {
  return <section id="account-content" data-nav="light" className="bg-background text-foreground py-12 md:py-16 min-h-[600px]">
      <div className="max-w-[1088px] mx-auto px-4 sm:px-6 md:px-8">
        <div className="bg-card text-card-foreground border border-border rounded-md p-6 sm:p-8 md:p-10 shadow-xs">
          <WooCommerceAccountBlock />
        </div>
      </div>
    </section>;
}